export default from './post-list-classic-header';



// WEBPACK FOOTER //
// ./app/components/post-list-classic-header/index.js